<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">

      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item size="small" style="width:15%">
              <el-select v-model="query.ismatch" clearable filterable placeholder="是否绑定" @change="query.ischange=true">
              	  <el-option v-for="(item,index) in matchlists" :label="item.name" :value="item.id" :key="index" />
              </el-select>
          </el-form-item>
          <el-form-item ref="query" :model="query" style="width:15%">
              <el-input placeholder="销售员名称 / 手机" v-model="query.key" clearable @keyup.enter.native="getList" @change="query.ischange=true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item>
            <input id="fileupload" type="file" @change="importfile(this)"  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display:none" title="1"/>
            <el-dropdown @command="downorupload">
                <el-button type="success" size="small" icon="el-icon-bottom">
                    导入导出关联模板<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="1">导出数据模板</el-dropdown-item>
                    <el-dropdown-item :command="2">导入匹配数据</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
      </el-form>

      <div class="backborder2" style="margin-top:10px">
          <el-table :data="clerklists" v-loading="query.loading">
              <el-table-column label="销售员名称" align="left">
                <template slot-scope="scope">
                    <div style="float:left;width:100%;font-size:13px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;line-height:27px">{{scope.row.name}}</div>
                </template>
              </el-table-column>
              <el-table-column label="销售员电话" align="left" width="150">
                <template slot-scope="scope">
                    <div style="float:left;width:100%;font-size:13px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;line-height:27px">{{scope.row.phone}}</div>
                </template>
              </el-table-column>
              <el-table-column label="是否绑定" align="center" width="150">
                <template slot-scope="scope">
                    <div style="font-size:13px">{{scope.row.yuncode && scope.row.yuncode!='' ? '已绑定' : '未绑定'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="管易云商品编号" align="center" width="150">
                <template slot-scope="scope">
                    <div style="font-size:13px">{{scope.row.yuncode}}</div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="120">
                <template slot-scope="scope">
                    <el-button type="warning" size="mini" icon="el-icon-edit" circle @click="getclerks(scope.row)" />
                </template>
              </el-table-column>
          </el-table>
          <div class="block">
            <!--分页begin-->
            <el-pagination
                @size-change="pageSizeChange"
                @current-change="pageCurrentChange"
                :current-page="query.p"
                :page-sizes="[10, 20, 50]"
                :page-size="query.rollpage"
                layout="total, sizes, prev, pager, next, jumper"
                :total="clerkrows">
            </el-pagination>
            <!--分页end-->
          </div>
      </div>


      <el-dialog title="设置销售员编号" :visible.sync="addclerkDialog" top="10vh" width="25%">
          <el-form :inline="true" class="demo-form-inline" size="small" v-loading="addclerkquery.loading">
              <el-form-item ref="query" :model="query" label="关联管易云编号" label-width="140">
                  <el-input  v-model="addclerkquery.code" clearable />
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="saveclerkcode">保 存</el-button>
          </div>
      </el-dialog>

  </div>
  </transition> 
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Kingdeecloud/index",
      transitionshow:true,
      actionauth:'',
      matchlists:[{id:1,name:'已绑定'},{id:2,name:'未绑定'}],
      query:{
        act:'getclerks',
        token:this.$cookies.get('token'),
        ismatch:'',
        loading:false,
        ischange:false,
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      clerklists:[],
      clerkrows:0,
      addclerkDialog:false,
      addclerkquery: {
          act:'matchclerks',
          token:this.$cookies.get('token'),
          loading:false,
          clerkid:'',
          code:''
      },

    }
  },

  mounted(){  
  	this.getactionauth(); //获取权限设置
    this.getList(); //获取客户列表信息
  },

  methods:{ 


      /** 上传或下载匹配数据 **/
      downorupload(type) {
          if(type==1) this.getdownmodel();
          if(type==2) this.uploadmodel();
      },   


      /** 下载模板数据 **/
      getdownmodel() {
          var url=this.GLOBAL.exportUrl+"Kingdeecloud/index/act/downclerkupload/token/"+this.$cookies.get('token');
          location.href=url;
      },

      /** 上传模板数据 **/
      uploadmodel() {
          document.getElementById("fileupload").click();
      },

      /************** 导入excel表格数据 **************/
    importfile(obj) {    
    	let _this = this;
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file = event.currentTarget.files[0];                
        var rABS = false; //是否将文件读取为二进制字符串
        var f = this.file;
        var outdata;
        var reader = new FileReader();
        FileReader.prototype.readAsBinaryString = function(f) {
        	var binary = "";
            var rABS = false; //是否将文件读取为二进制字符串
            var pt = this;
            var wb; //读取完成的数据
            var reader = new FileReader();
            reader.onload = function(e) {
            	var bytes = new Uint8Array(reader.result);
                var length = bytes.byteLength;
                for(var i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
                var XLSX = require('xlsx');
                if(rABS) {
                	wb = XLSX.read(btoa(fixdata(binary)), {type:'base64'});
                }else {
                    wb = XLSX.read(binary, {type: 'binary'});
                }
                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
                //清空输入框的文件值，避免下次change事件失效
                document.getElementById('fileupload').value = null;

                if(outdata.length > 500) {_this.$message.error('请一次上传数据不要超过500条');return false;}

                var loading=_this.$loading({
					lock: true,
					text: '数据玩命上传中，请稍后...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.8)'
				});	
                
                //提交数据到后台
        		var resource = _this.$resource(_this.url);
                resource.save({act:'inputclerkmatch',infos:outdata,token:_this.$cookies.get('token')}).then((res) => {
                    if(res.data.Result>0){
                    	if(res.data.Result=='70001') this.$router.push('/login')
                    	_this.$message({
				    		dangerouslyUseHTMLString: true,
				    		type:'error',
				    		message:'<span style="line-height:20px">'+res.data.Message+'</span>',
			    		});
                        loading.close();
                    }else{
                    	_this.getList();
                    	_this.$message.success('导入商品信息成功!');
                        loading.close();
                  	}
                }).catch((res) => {
                    _this.$message.error(this.GLOBAL.errortext);
                    loading.close();
                });        
                           
            }
            reader.readAsArrayBuffer(f);
        }
               
        if(rABS) {
        	reader.readAsArrayBuffer(f);
        } else {
            reader.readAsBinaryString(f);
        }                 
    },
    /************************** 导入excel表格数据 ****************************************/



      /** 获取商品匹配明细 **/
      getclerks(item) {
          this.addclerkDialog=true;
          this.addclerkquery.clerkid=item.id;
          this.addclerkquery.code='';

          this.addclerkquery.loading = true;
          var resource = this.$resource(this.url);
          resource.save({act:'getclerkinfo',token:this.$cookies.get('token'),clerkid:this.addclerkquery.clerkid}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.addclerkquery.loading = false;
            }else{
                var result = JSON.parse(Base64.decode(res.data.Data));
                result.code ? this.addclerkquery.code=result.code : '';
                this.addclerkquery.loading = false;	            		
            }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
              this.addclerkquery.loading = false;	  
          });
      },

      /** 保存商品匹配信息 **/
      saveclerkcode() {
          var resource = this.$resource(this.url);
          resource.save(this.addclerkquery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                  this.addclerkDialog=false;
                  this.getList();      		
            }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);  
          });
      },



      /** 获取操作功能权限 **/
  	  getactionauth() {
    	    var data =this.$cookies.get('actionauth');
    	    data=JSON.parse(data);
          this.actionauth=data;
      },

      /** 获取商品信息列表 **/
      getList() {
          if(this.query.ischange=true) {
              this.query.p=1;
              this.query.rollpage=10;
          }

          this.query.loading = true;
          var resource = this.$resource(this.url);
          resource.save(this.query).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.query.loading = false;
            }else{
                this.clerklists = JSON.parse(Base64.decode(res.data.Data));
                this.clerkrows=parseInt(res.data.count);
                this.query.loading = false;	            		
            }
            if(this.query.ischange==true) this.query.ischange=false;
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
              this.query.loading = false;	  
          });
      },
      pageSizeChange(val) {
          this.query.rollpage = val;
          this.getList();
      },
      pageCurrentChange(val) {
          this.query.p = val;
          this.getList();
      },  

      

  },
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/kingdeeyun/Yunclerks.vue